<div>
    <app-application-create-edit (parentComp)="reloadTable($event)"></app-application-create-edit>
  </div>
  
  <!-- HEADER -->
  <app-screen-heading [title]="'AuditLogs'" [hideButtonsOnSmallScreen]="false" [hideBottomBorder]="false">
    <ng-container smallScreenButtons>
    </ng-container>
    <ng-container regularButtons>
    </ng-container>
  </app-screen-heading>
  
  <!-- FILTERS -->
  <!-- <app-table-filter [showSearch]="true" [searchPlaceholder]="'Search by Name'"
    (filterChange)="handleChangeFilter($event)">
  </app-table-filter> -->
  
  <div class="page-table">
    <table>
      <thead>
        <tr class="header-columns">
          <td><span>Time</span></td>
          <td><span>Controller</span></td>
          <td><span>Action</span></td>
          <td><span>Response</span></td>          
          <td><span>User</span></td>
          <td><span>ApiKey</span></td>
        </tr>
      </thead>
  
      <tbody>
        <tr *ngFor="let item of auditLogs" class="bodyRow clickable actions-click">
          <td><span>{{item.time | date:'short'}}</span></td>
          <td><span>{{item.controller | hasValue}}</span></td>
          <td><span>{{item.action | hasValue}}</span></td>
          <td><span>{{item.response | hasValue}}</span></td>
          <td><span>{{item.user | hasValue}}</span></td>
          <td><span>{{item.application | hasValue}}</span></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="pagination-wrapper">
    <app-pagination [pageSize]="pageSize" [currentPage]="currentPage" [count]="count" (pageChange)="pageChange($event)">
    </app-pagination>
